export const BASE_TEMPLATE = "/api/template";
export const BASE_MEDIA = "/api/media";
